import { Typography } from '@arco-design/web-react';
import DetailSection from '../DetailSection';

export interface TicketTextPanelProps {
  /** 工单内容（正文） */
  content?: string;
  /** 工单描述（AI 分类依据 / 详细问题描述） */
  description?: string;
}

/** 工单详情「内容 / 描述」两段只读正文：两段都有则依次渲染，都为空则整块不渲染。 */
export default function TicketTextPanel({ content, description }: TicketTextPanelProps) {
  if (!content && !description) return null;
  return (
    <div>
      {/* 正文分节统一走 DetailSection（与「基本信息」同一套标题），不再自写灰色小标题：
          同一弹层内出现两种分节标题会让层级读不出来 */}
      {content && (
        <DetailSection title="内容">
          <Typography.Paragraph
            style={{ margin: 0, fontSize: 13, lineHeight: 1.8, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
          >
            {content}
          </Typography.Paragraph>
        </DetailSection>
      )}
      {description && (
        <DetailSection title="描述">
          <Typography.Paragraph
            style={{ margin: 0, fontSize: 13, lineHeight: 1.8, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
          >
            {description}
          </Typography.Paragraph>
        </DetailSection>
      )}
    </div>
  );
}
